import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { FragnoDropdown } from 'fragno/react';
import { useTranslation } from 'react-i18next';
import { USE_FOR_OPTIONS } from '../../../constants/emailOptions';

const UseForDropdown = ({ emailId, value, onChange }) => {
  const { t } = useTranslation();

  const handleChange = useCallback(
    (newValue) => {
      if (newValue && newValue !== value) {
        onChange(emailId, newValue);
      }
    },
    [emailId, value, onChange],
  );

  const options = USE_FOR_OPTIONS.map((opt) => ({
    value: opt.value,
    label: t(opt.label),
  }));

  return (
    <FragnoDropdown
      data-testid="email-use-for"
      options={options}
      value={value}
      placeholder={t('walletEmails.selectUse')}
      onChange={handleChange}
    />
  );
};

UseForDropdown.propTypes = {
  emailId: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default memo(UseForDropdown);
